import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyD0QfenuzVWfO7itRglqf0JvMM-U4TuyUA",
    authDomain: "sample-blog-vue.firebaseapp.com",
    projectId: "sample-blog-vue",
    storageBucket: "sample-blog-vue.appspot.com",
    messagingSenderId: "8340124320",
    appId: "1:8340124320:web:62973de9ed4b25a9230fc5"
};

firebase.initializeApp(firebaseConfig);
let db = firebase.firestore();
let auth = firebase.auth();
let timeStamp = firebase.firestore.FieldValue.serverTimestamp;

export {db, timeStamp, auth};